import React from 'react';

const CardWrapper = (props) =>
<div className={"card col-11 col-md-8 mx-auto mt-4 mb-5" + (props.hasOwnProperty('classSelector') ? " " + props.classSelector : "")}>
    <div className="card-body">
        {props.children}
    </div>
</div>

export default CardWrapper;